import { cn } from '@/utils/cn';

/** Neutral placeholder block used while data loads. */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('bg-line/70 animate-pulse rounded', className)} aria-hidden />;
}

/**
 * Table-shaped loading state.
 *
 * Mirrors the real row height so the layout does not jump when data arrives — a spinner in a
 * table body causes a visible reflow on every fetch.
 */
export function SkeletonRows({ rows = 4, columns = 4 }: { rows?: number; columns?: number }) {
  return (
    <div className="divide-line divide-y">
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className="flex items-center gap-4 px-5 py-3.5">
          {Array.from({ length: columns }).map((__, columnIndex) => (
            <Skeleton
              key={columnIndex}
              className={cn('h-4 flex-1', columnIndex === 0 && 'max-w-24')}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
